
import { mapGetters, mapActions } from 'vuex'
import SsrCarousel from 'vue-ssr-carousel'
import productData from '@/data/products.json'
import reviewData from '@/data/reviews.json'

export default {
  components: { SsrCarousel },
  props: {
    priority: {
      type: String,
      default: 'true',
    },
    region: {
      type: String,
      default: 'UK',
    },
    special: {
      type: String,
      default: 'true',
    },
    standard: {
      type: String,
      default: 'true',
    },
    cotm: {
      type: String,
      default: 'true',
    },
    bf: {
      type: String,
      default: 'false',
    },
    cm: {
      type: String,
      default: 'false',
    },
    prebf: {
      type: String,
      default: 'false',
    },
    ultimatebundle: {
      type: String,
      default: 'true',
    },
    advanced: {
      type: String,
      default: 'false',
    }
  },
  data() {
    return {
      products: productData,
      productsToShow: [],
      addLoading: false,
      discount_amount: 0,
      discount_type: 0,
      offer_code: '',
      date_text: '',
      reviews: reviewData,
      courses: [
        { id: 25,    modalId: '120includedcard' },
        { id: 10168, modalId: '140includedcard' },
        { id: 10204, modalId: '250includedcard' },
        { id: 10400, modalId: '120audioincludedcard' },
        { id: 10191, modalId: '40teoincludedcard' },
        { id: 105,   modalId: '30tylincludedcard' },
        { id: 106,   modalId: '30tbeincludedcard' },
      ],
    }
  },

  computed: {
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
      price_label: 'cart/getPriceLabel',
      cart: 'cart/cartProducts',
      serverCart: 'cart/getServerCart',
      currentDiscountCode: 'cart/getDiscount',
      currentAffiliateCode: 'cart/getAffiliate',
      cartTotals: 'cart/getTotals',
      error: 'cart/getErrorStatus',
      priceLabel: 'cart/getPriceLabel',
      orderId: 'cart/getOrderId',
      activeModal: 'pages/getActiveModal',
      showModal: 'cart/showAdded',
    }),

    // Resolves the active region from Vuex — userRegion takes priority over detected
    currentRegion() {
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },

    // True if the current region is US
    isUSRegion() {
      return this.currentRegion && this.currentRegion.includes('us')
    },

    // Pass the actual resolved region to CourseCard so it can look up the correct promo data.
    // Previously this only returned 'en' or 'en_us', causing all non-US regions (e.g. CA) to
    // incorrectly receive the EN special offer.
    regionToShow() {
      return this.currentRegion || 'en'
    },

    currentActiveModalCourse() {
      if (!this.activeModal) return null
      return this.courses.find(course => course.modalId === this.activeModal) || null
    },

    // True if there's an active big campaign offer for the current region (used for timeline blocks)
    campaignActiveForRegion() {
      if (!this.$campaign || !this.$campaign.isActive) return false
      const offer = this.$campaign.offerForRegion(this.currentRegion)
      return !!(offer && offer.offerText)
    },

    pdfBundle() {
      const product = productData.find((course) => {
        return course.id === parseInt(20100)
      })
      product.priceData = this.$options.filters.priceData(product)
      product.onSale = product.priceData.saleType !== 'none'
      return product
    },
  },

  methods: {
    ...mapActions({
      remove: 'cart/removeFromCartServer',
      addDiscount: 'cart/addDiscountServer',
      removeDiscount: 'cart/removeDiscountServer',
      addAffiliate: 'cart/addAffiliateServer',
      removeAffiliate: 'cart/removeAffiliateServer',
      addToCart: 'cart/addToCartServer',
      resetCart: 'cart/resetCart',
      hideError: 'cart/hideError',
      switchProduct: 'cart/switchProductServer',
      revertProduct: 'cart/revertProductServer',
      updateActiveModal: 'pages/updateActiveModal',
    }),
    getRegion(region) {
      if (region === 'en-us') {
        return 'us'
      } else {
        return 'uk'
      }
    },
    cardImage(thumbnail) {
      const imgUrl = this.$img(this.$options.filters.cdn(thumbnail), { format: 'webp', quality: 50, width: '600px' })
      return {
        backgroundImage: `url('${imgUrl}')`
      }
    },
    limit(string, limit) {
      return string.substring(0, limit) + '...'
    },
    updateModal(id) {
      this.updateActiveModal(id)
    },
    hideModal() {
      this.updateActiveModal(null)
    },
    addToCartLoading(data) {
      this.addLoading = true
      return this.addToCart(data).then(res => {
        this.addLoading = false
      }).catch(err => {
        console.log(err)
        this.addLoading = false
      })
    }
  },
}
